import React, { useState, useEffect, useRef } from 'react';
import { Popover, PopoverContent, PopoverBody } from '@chakra-ui/react';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';
import CreatableSelect from 'react-select/creatable';
import Cookies from 'js-cookie';
 
const OptionMenu = ({
  anchorRef,
  trigger,
  onClose,
  task,
  status,
  getTaskBoardDetails,
}) => {

  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [labelNote, setLabelNote] = useState('');
  const popoverRef = useRef(null);
  const [showPopover, setShowPopover] = useState(true);
  const [opendeleteModal, setdeletModal] = useState(false);
  const [labellist, setLabelList] = useState([]);
  const roleId = Number(Cookies.get('task-role-id'));
 
  const closePopover = () => {
    setShowPopover(false);
    onClose(); 
  };
 
 
  const [anchorStyle, setAnchorStyle] = useState({});
 
  useEffect(() => {
    if (!anchorRef) return;
 
    const rect = anchorRef.getBoundingClientRect();
    setAnchorStyle({
      position: 'absolute',
      top: `${rect.bottom + window.scrollY - 250}px`,
      left: `${rect.left + window.scrollX - 350}px`,
      zIndex: 10000,
      width: '240px',
      background: 'white',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      borderRadius: '8px',
      padding: '8px 0',
    });
    setShowPopover(true);
  }, [anchorRef, trigger]);
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        anchorRef &&
        !anchorRef.contains(event.target)
      ) {
        setShowPopover(false); // close popover on outside click
        onClose(); // notify parent if needed
      }
    };
 
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [anchorRef, onClose]);
 
  const handleStatusChange = async (selectedStatus) => {
    try {
      const reqBody = {
        project_id: task.project_id,
        issue_id: task.task.issue_id,
        issue_status: selectedStatus.status_name.toUpperCase(),
      };
      const response = await httpInjectorService.taskUpdateStatus(reqBody);
      if (response.status === 'success') {
        setShowPopover(false);
        getTaskBoardDetails();
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
     throw error
    } finally {
      setShowStatusOptions(false);
      onClose();
    }
  };
 
  const deleteTask = async () => {
    try {
      const response = await httpInjectorService.deleteTask({
        issue_id: task.task.issue_id,
        project_id: task.project_id,
      });
      if (response.status === 'success') {
        setdeletModal(false);
        getTaskBoardDetails();
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
     throw error
    }
  };
 
  
  const handleAddLabel = async () => {
    try {
      if (!selectedLabel || selectedLabel.length === 0) return;
 
      const newLabels = selectedLabel.filter((label) => label.__isNew__);
      const existingLabels = selectedLabel.filter((label) => !label.__isNew__);
 
      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);
 
      const requestBody = {
        project_id: task.project_id,
        issue_id: task.task.issue_id,
        sprint_id: task.task.sprint_id,
      };
 
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }
 
      if (existingLabelIds.length > 0) {
        requestBody.labels_id = existingLabelIds;
      }
 
      const response = await httpInjectorService.createLabel(requestBody);
 
      if (response.status === 'success') {
        toast.success(response.message || 'Labels added to task successfully', {
          position: 'top-right',
          autoClose: 3000,
        });
        getTaskBoardDetails();
      } else {
        toast.error(response.message || 'Failed to add labels', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
 
      setIsLabelModalOpen(false);
      setSelectedLabel([]);
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };
 
  const handledeletetask = () => {
    setShowPopover(false);
    setdeletModal(true);
  };
 
  const handleDeleteModalClose = () => {
    setdeletModal(false);
  };
 
  const handleLabelModalClose = () => {
    setIsLabelModalOpen(false);
    setSelectedLabel('');
    setLabelNote('');
  };
 
  const handleLabel = async () => {
    setShowPopover(false);
    getLabelList();
    setShowStatusOptions(false);
    setIsLabelModalOpen(true);
    
    try {
      const response = await httpInjectorService.getLabelList(task.project_id);
      if (response.status === 'success') {
        setLabels(response.data);
      } else {
        toast.error('Failed to load labels');
      }
    } catch (error) {
    throw error
    }
  };
 
  const getLabelList = async () => {
    try {
      let response = await httpInjectorService.getLabelList(task.project_id);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
     throw error
    }
  };
 
  const menuItems = [
    {
      label: 'Change status',
      action: () => setShowStatusOptions((prev) => !prev),
      isExpandable: true,
    },
    // { label: 'Copy link', action: () => console.log('Copy link', task) },
    // { label: 'Copy key', action: () => console.log('Copy key', task) },
    // { label: 'Add flag', action: () => console.log('Add flag', task) },
    { label: 'Add label', action: () => handleLabel() },
    // {
    //   label: 'Link work item',
    //   action: () => console.log('Link work item', task),
    // },
    // { label: 'Delete', action: () => handledeletetask(), danger: true },
    ...([1, 2, 3].includes(roleId)
      ? [{ label: 'Delete', action: () => handledeletetask(), danger: true }]
      : []),
  ];
 
  return (
    <>
      {showPopover && (
        <div style={anchorStyle} ref={popoverRef}>
          <Popover
            isOpen={showPopover}
            onClose={closePopover}
            isLazy
            closeOnBlur={false}
            autoFocus={false}
          >
            {anchorRef && (
              <PopoverContent
                zIndex={9999}
                width="240px"
                borderRadius="8px"
                boxShadow="md"
                padding="0"
              >
                <PopoverBody p="4px 0">
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {menuItems.map((item) => (
                      <div key={item.label} style={{ position: 'relative' }}>
                        <button
                          onClick={item.action}
                          style={{
                            padding: '8px 16px',
                            background: 'none',
                            border: 'none',
                            textAlign: 'left',
                            cursor: 'pointer',
                            color: item.danger ? 'red' : '#333',
                            fontSize: '14px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            transition: 'background 0.2s',
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.background = '#f1f1f1')
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.background = 'transparent')
                          }
                        >
                          <span>{item.label}</span>
                          {item.isExpandable ? (
                            <span style={{ fontSize: '12px', color: '#888' }}>
                              ▶
                            </span>
                          ) : (
                            <span style={{ fontSize: '12px', color: '#888' }}>
                              ›
                            </span>
                          )}
                        </button>
 
                        {item.label === 'Change status' &&
                          showStatusOptions && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: '100%',
                                marginLeft: '4px',
                                background: '#fff',
                                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                zIndex: 99999,
                                padding: '4px 0',
                                width: '180px',
                              }}
                            >
                              {status.map((s) => (
                                <button
                                  key={s.id}
                                  onClick={() => handleStatusChange(s)}
                                  style={{
                                    padding: '6px 12px',
                                    background: 'none',
                                    border: 'none',
                                    textAlign: 'left',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    color: '#333',
                                    width: '100%',
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background =
                                      '#f9f9f9')
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background =
                                      'transparent')
                                  }
                                >
                                  {s.status_name}
                                </button>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </PopoverBody>
              </PopoverContent>
            )}
          </Popover>
        </div>
      )}
 
      {/* Add Label Modal */}
      <Modal isOpen={isLabelModalOpen} onClose={handleLabelModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Label to {task.epic_key}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {/* <Select
              placeholder="Select label"
              value={selectedLabel}
              onChange={(e) => setSelectedLabel(e.target.value)}
              mb={4}
            >
              {labellist.map((label) => (
                <option key={label.label_id} value={label.label_id}>
                  {label.label_name}
                </option>
              ))}
            </Select> */}
            {/* <Select
  placeholder="Select label"
  value={JSON.stringify(selectedLabel)}
  onChange={(e) => setSelectedLabel(JSON.parse(e.target.value))}
  mb={4}
>
  {labellist.map((label) => (
    <option key={label.label_id} value={JSON.stringify(label)}>
      {label.label_name}
    </option>
  ))}
</Select> */}
           <CreatableSelect
  placeholder="Select or create label"
  isClearable
  isMulti
  value={selectedLabel}
  options={labellist.map((label) => ({
    label: label.label_name,
    value: label.label_id,
    __isNew__: false,
  }))}
  onChange={(newValue) => {
    if (!newValue) {
      setSelectedLabel([]);
      return;
    }
 
    const uniqueLabels = [];
    const seen = new Set();
 
    newValue.forEach((label) => {
      const normalized = label.label.toLowerCase();
 
      if (!seen.has(normalized)) {
        seen.add(normalized);
 
        // ✅ if label already exists in labellist (case-insensitive), reuse it
        const existing = labellist.find(
          (opt) => opt.label_name.toLowerCase() === normalized
        );
 
        if (existing) {
          uniqueLabels.push({
            label: existing.label_name,
            value: existing.label_id,
            __isNew__: false,
          });
        } else {
          uniqueLabels.push(label); // keep newly created label
        }
      }
    });
 
    setSelectedLabel(uniqueLabels);
  }}
  formatCreateLabel={(inputValue) => `Create new label: "${inputValue}"`}
  isValidNewOption={(inputValue, _, options) =>
    inputValue.trim() !== "" &&
    !options.some(
      (option) => option.label.toLowerCase() === inputValue.toLowerCase()
    )
  }
/>
 
 
 
            {/* <Input
              placeholder="Add a note (optional)"
              value={labelNote}
              onChange={(e) => setLabelNote(e.target.value)}
            /> */}
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
              mr={3}
              onClick={handleAddLabel}
            >
              Done
            </Button>
            <Button variant="ghost" onClick={handleLabelModalClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
 
      <Modal isOpen={opendeleteModal} onClose={handleDeleteModalClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to delete the task?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>This action cannot be undone.</Text>
            <Text>Please confirm if you really want to proceed.</Text>
          </ModalBody>
          <ModalFooter>
            <Button
              bg="#722ED1"
              color="white"
              size="sm"
              _hover={{ bg: '#5a1fb3' }}
              mr={3}
              onClick={deleteTask}
            >
              Confirm
            </Button>
            <Button variant="ghost" onClick={handleDeleteModalClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
 
export default OptionMenu;